import { Injectable } from "@angular/core";
import { PollingPort } from "../ports/polling.port";

/**
 * Adapter (Implementação) de polling usando setInterval
 * Implementa o contrato definido pelo PollingPort
 */
@Injectable()
export class IntervalPollingAdapter extends PollingPort {
  private intervalId?: any;

  start(callback: () => void, intervalMs: number): void {
    if (this.intervalId) {
      this.stop();
    }

    this.intervalId = setInterval(() => {
      callback();
    }, intervalMs);
  }

  stop(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = undefined;
    }
  }

  isRunning(): boolean {
    return this.intervalId !== undefined;
  }
}
